import * as React from "react";
import { connect } from "react-redux";
import { IdMenuBalancing } from "../../../../constants/IdMenuBalancing";
import { IdResource } from "../../../../constants/IdResource";
import { componentWithProps } from "../../../generic/componentWithProps";
import { ResourceBar } from "../../../generic/resource-bar/ResourceBar";
import { MenuWrapper } from "../../../menus/MenuWrapper";
import { actionModalClose } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
export var _MenuQuests = function (_a) {
    var onClose = _a.onClose;
    var footerResources = [IdResource.Money, IdResource.Gold];
    var footerComponent = componentWithProps({
        ComponentType: ResourceBar,
        resources: footerResources,
    });
    return (React.createElement(MenuWrapper, { type: IdMenuBalancing.Quest, onClose: onClose, className: "quests-dialog", footerRenderer: footerComponent, modalId: IdModal.Quests }));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.Quests)); },
}); };
export var MenuQuests = connect(undefined, mapDispatch)(_MenuQuests);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/MenuQuests.tsx
// module id = 2843
// module chunks = 3